var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVeteranIconWhite = function SvgVeteranIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.34 26.4v48.48c-64.12 29.02-128.84 51.7-193.22 68.05V94.45C370.49 78.1 435.21 55.42 499.34 26.4zM499.34 123.37v48.48c-64.12 29.02-128.84 51.7-193.22 68.05v-48.48c64.37-16.35 129.09-39.03 193.22-68.05zM499.34 220.34v48.48c-64.12 29.02-128.84 51.7-193.22 68.05v-48.48c64.37-16.35 129.09-39.03 193.22-68.05zM306.11 94.45V72.82c0-14.99-13.18-26.9-28.02-24.75C185.62 61.42 93.14 134.21.66 134.21v145.45c101.82 0 203.63-88.24 305.45-88.24v-48.48c-36.47 0-72.94 11.32-109.42 25.86v-48.48c36.48-14.54 72.95-25.87 109.42-25.87zM.66 328.15c101.82 0 203.63-88.24 305.45-88.24v48.48c-101.82 0-203.63 88.24-305.45 88.24v-48.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.11 384.56v-47.69c-101.82 0-203.63 88.24-305.45 88.24v48.48c83.89 0 167.78-59.9 251.67-81v21.73c0 16.03 14.91 27.95 30.54 24.35 72.03-16.61 144.62-41.17 216.47-73.68v-48.48c-64.13 29.02-128.84 51.7-193.23 68.05z"
  }))));
};
export default SvgVeteranIconWhite;